import React from 'react';

import { NavbarSection } from './styled';
import { useAppContext } from '../../../context';
import { lazyWithPreload } from '../../../utilities/lazy-with-preload';

const FramkyLogoNavbar = lazyWithPreload(() => import(/* webpackChunkName: 'FramkyLogoNavbar'  */ './FramkyLogoNavbar'));

function NavbarWrapper() {
    const { isMobile } = useAppContext();

    return (
        <NavbarSection $isMobile={isMobile}>
            <FramkyLogoNavbar />
        </NavbarSection>
    );
}

export default NavbarWrapper;
